<div
  class="presenter-widget-wrapper"
  [class.editable]="draggable"
  [class.show-guide-x]="showGuidesX"
  [class.show-guide-y]="showGuidesY"
  [class.show-guide-left]="showGuideLeft"
  [class.show-guide-right]="showGuideRight"
  [class.show-guide-top]="showGuideTop"
  [class.show-guide-bottom]="showGuideBottom"
  [ngStyle]="wrapperStyle"
  [class.is-selected]="isSelected$ | async"
  cdkDrag
  [cdkDragScale]="zoomLevel()"
  [cdkDragDisabled]="!draggable || isResizing"
  (cdkDragEnded)="onDragEnded($event)"
  [attr.data-widget-id]="widget.uuid"
  [cdkDragConstrainPosition]="constrainPosition"
  #wrapperEl
>
  <div class="widget-content">
    <ng-content></ng-content>
  </div>

  @if ((isSelected$ | async) && draggable) {
    <div class="resize-handle handle-nw" (pointerdown)="onResizePointerDown($event, 'nw')"></div>
    <div class="resize-handle handle-ne" (pointerdown)="onResizePointerDown($event, 'ne')"></div>
    <div class="resize-handle handle-sw" (pointerdown)="onResizePointerDown($event, 'sw')"></div>
    <div class="resize-handle handle-se" (pointerdown)="onResizePointerDown($event, 'se')"></div>

    @if (!cornerOnlyResize) {
      <div class="resize-handle resize-handle-side handle-n" (pointerdown)="onResizePointerDown($event, 'n')"></div>
      <div class="resize-handle resize-handle-side handle-e" (pointerdown)="onResizePointerDown($event, 'e')"></div>
      <div class="resize-handle resize-handle-side handle-s" (pointerdown)="onResizePointerDown($event, 's')"></div>
      <div class="resize-handle resize-handle-side handle-w" (pointerdown)="onResizePointerDown($event, 'w')"></div>
    }
  }
</div>
